import React from 'react';
// import * as firebase from 'firebase';
import firebase from '../helper/firebase';

import _ from 'lodash';

// import {
//   Link
// } from 'react-router-dom'

// import JobCardHeader from '../components/JobCardHeader'
// import JobCardContent from '../components/JobCardContent'
// import JobCardReferees from '../components/JobCardReferees'
// import UnpublishedJob from '../components/UnpublishedJob'
import Head from '../components/Head';
import JobCardHeader from '../components/JobCardHeader';
import JobCardContent from '../components/JobCardContent';
import JobCardReferees from '../components/JobCardReferees';
import IDNotFound from '../components/IDNotFound';
import LoggedOutCard from '../components/LoggedOutCard';

import {
	Button,
	CircularProgress,
	Card,
	CardActions,
	Divider
} from 'material-ui';

import { ReactGoogleAnalytics } from '../helper/functions';

import { Title } from '../helper/consts';

import Fade from 'material-ui/transitions/Fade';
// import MobileStepper from 'material-ui/MobileStepper'

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	referees: {
		display: 'flex',
		flexWrap: 'wrap'
	},
	chip: {
		margin: '5px 10px 5px 0'
	}
};

export default class Commission extends React.Component {
	constructor() {
		super();

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			commission: {}
		};
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getInfo(user.uid);
				this.setState({
					uid: user.uid,
					user: user.providerData[0],
					jid: this.props.match.params.jid,
					loggedIn: true,
					authLoading: false,
					loading: true
				});
			} else {
				this.setState({
					loggedIn: false,
					authLoading: false,
					loading: true
				});
			}
		});
	}

	getInfo = uid => {
		const { jid } = this.props.match.params;
		const ref = firebase.database().ref();
		let promises = [];
		ref
			.child(`myCommissions/${uid}/${jid}`)
			.once('value')
			.then(snap => {
				if (snap.val() !== null) {
					let commission = snap.val();
					const offerPromise = firebase
						.firestore()
						.collection('offers')
						.doc(commission.oid)
						.get()
						.then(offerSnap => {
							commission['referees'] = offerSnap.data();
							this.setState({ commission });
						});
					promises.push(offerPromise);
					// const jobPromise = ref.child(`jobs/${jid}`).once('value').then(jobSnap=>{
					const jobPromise = firebase
						.firestore()
						.collection('jobs')
						.doc(jid)
						.get()
						.then(jobSnap => {
							if (jobSnap.data() !== null) {
								this.setState({
									job: jobSnap.data()
								});
							} else {
								this.setState({
									job: {}
								});
							}
						});
					promises.push(jobPromise);
					Promise.all(promises)
						.then(() => {
							this.setState({
								loading: false
							});
						})
						.catch(err => {
							console.log(err);
						});
				} else {
					this.setState({
						commission: {},
						loading: false
					});
				}
			});
	};

	renderCommissionCard = () => {
		const { commission, job } = this.state;
		let html = [];
		let card = (
			<Fade key={job.jid} in={true}>
				<Card className="card">
					<JobCardHeader job={job} />
					<Divider light />
					<JobCardContent wrap={true} job={job} />
					<JobCardReferees
						shareCount="hide"
						photoURL={this.state.user.photoURL}
						users={commission.referees}
						uid={this.state.uid}
						displayName={this.state.user.displayName}
					/>
					<Divider light />
					<CardActions className="cardActions">
						{commission.status === 'pending' ? (
							<Button
								className="cardActionsBtn"
								onClick={this.redeem}
								raised
								color="accent"
							>{`Redeem $${commission.commission.toFixed(0)}`}</Button>
						) : null}
						{commission.status === 'requested' ? (
							<Button
								className="cardActionsBtn"
								disabled
								raised
								color="primary"
							>{`$${commission.commission.toFixed(0)} Requested`}</Button>
						) : null}
						{commission.status === 'paid' ? (
							<Button
								className="cardActionsBtn"
								disabled
							>{`$${commission.commission.toFixed(0)} Paid`}</Button>
						) : null}
						{commission.status === 'declined' ? (
							<Button
								className="cardActionsBtn"
								disabled
							>{`$${commission.commission.toFixed(0)} Declined`}</Button>
						) : null}
					</CardActions>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	redeem = () => {
		const { commission, uid, job } = this.state;
		const ref = firebase.database().ref();
		const newStatus = 'requested';
		let update = {};
		update[`myCommissions/${uid}/${job.jid}/status`] = newStatus;
		// update[`commissions/${job.jid}/${uid}`] = {
		//   commission:commission.commission,
		//   status:newStatus,
		//   oid:commission.oid,
		//   jid:job.jid,
		//   timestamp:Date.now(),
		// };
		ref
			.update(update)
			.then(() => {
				ReactGoogleAnalytics('Commissions', 'Redeem', job.jid, null, null);
				commission['status'] = newStatus;
				this.setState({
					commission
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Commission | ${Title}`} />
				<div id={this.state.loggedIn ? 'loggedInBody' : null} className="body">
					{(this.state.loading &&
						this.state.authLoading &&
						!this.state.loggedIn) ||
					(this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn) ? (
						<CircularProgress style={style.loading} size={75} />
					) : null}

					{!this.state.loading &&
					!this.state.authLoading &&
					this.state.loggedIn &&
					(_.isEmpty(this.state.commission) ||
						_.isEmpty(this.state.job).length) ? (
						<IDNotFound key="no ID" user={this.state.user} />
					) : null}

					{!this.state.loading &&
					!this.state.authLoading &&
					this.state.loggedIn &&
					!(
						_.isEmpty(this.state.commission) || _.isEmpty(this.state.job).length
					)
						? this.renderCommissionCard()
						: null}

					{this.state.loading &&
					!this.state.authLoading &&
					!this.state.loggedIn ? (
						<LoggedOutCard />
					) : null}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Commission.js